import {storeSessionKey, TOKEN_KEY, ENV_KEY, USERNAME_KEY, getSessionKey, TOKEN_EXPIRE_TIME} from '../../util/storage'
import {getTokenExpireTime} from '../../util/helpers'

export const refreshToken = (pwd) => ({apis}) => {
  const reqData = {
    username: getSessionKey(USERNAME_KEY),
    password: pwd,
  }
  const config = {
    'Content-Type': 'application/json',
  }
  const payload = apis.authenticateUser(reqData, config, getSessionKey(ENV_KEY)).map((x) => {
    if (x && x.token) {
      storeSessionKey(TOKEN_KEY, x.token)
      storeSessionKey(TOKEN_EXPIRE_TIME, '' + getTokenExpireTime())
    }
    return x
  })
  return {
    type: 'REFRESH_TOKEN',
    payload,
  }
}

export const resetTokenRefreshFlag = () => ({
  type: 'RESET_REFRESH_TOKEN_FLAG',
})



// WEBPACK FOOTER //
// ./src/store/refresh-token/actions.js